import { render, staticRenderFns } from "./GroupHead.vue?vue&type=template&id=6dbffe3f&scoped=true"
import script from "./GroupHead.vue?vue&type=script&lang=js"
export * from "./GroupHead.vue?vue&type=script&lang=js"
import style0 from "./GroupHead.vue?vue&type=style&index=0&id=6dbffe3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbffe3f",
  null
  
)

export default component.exports